import React, { Component } from 'react';
import work from '../shared-components/experience';
import './work.css';
import { FaPhoneAlt, FaLinkedinIn, FaFacebook, FaMailBulk} from 'react-icons/fa';


class Work extends Component {

  render() {

    return (
      <div className="mainContainer">
        <div className="parallax-container-wrapper">
          <h4 className="align-center section-header">Projects and Companies where I worked</h4>
          <div className="work-container">
            <div className="timeline">
              {
                work.map(function(item, index) {
                  return(
                      <div key={item.id} className={`content-wrapper ${index % 2 === 0 ? 'left' : 'right'}`}>
                        <div className="content">
                          <div className="date-image-wrapper">
                            <div className="tenure">
                              {item.tenure}
                            </div>
                            <div>
                              <div className="image-wrapper">
                                {
                                  item.paths.map(function(image, index) {
                                    return (
                                      <div>
                                        <div className={`client-company-tag ${index % 2 === 0 ? 'company' : 'client'}`}>{`${index % 2 === 0 ? 'company' : 'client'}`}</div>
                                        <img key={index} className="company-logo" alt={image.alt} src={require(`../assets/${image.path}`)} />
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          </div>
                          <p className="project-description">
                            {item.description}
                            <br />  <br />
                            {item.responsibilities}
                            <br />  <br />
                            <div className="technologies">
                              {item.technologies.map(function(skill, index) {
                                return (
                                <div key={index} className="technologies-chips">{skill}</div>
                                )
                              })}
                            </div>
                          </p>
                        </div>
                      </div>
                  );
                })
              }
            </div>    
          </div>  
        </div>

        <div className="footer">
          <a href="https://www.facebook.com/vasanth.anishetty" target="_blank" rel="noopener noreferrer"><FaFacebook /> FACEBOOK</a> 
          <a href="https://www.linkedin.com/in/vasanth-kumar-anisetty-922a1943/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn/> LINKEDIN</a>
          <div><FaMailBulk /> vasanthr07@gmail.com</div>
          <div><FaPhoneAlt /> +91-8019469447 </div>
        </div>
      </div>
    )
  }
}

export default Work;
